function AuditCtrl($scope,$interval,$timeout,$filter,$rootScope, $state, $element, DateRangeService) {

    var timezoneOffset =  (new Date().getTimezoneOffset()*60000);

    $scope.dateRange = DateRangeService.getNewRange();
    DateRangeService.initDateRange($scope.dateRange, true);

    $scope.currentZoom = 1;
    $scope.data = {};
    $scope.auData = [];
    $scope.aggregationConfig = {};
    $scope.refreshtable = false;
    $scope.currentChanges = [];
    $scope.pageSize = 9;

    var addFilter;
    var EMPTY_STRING = "(empty)";
    var screenHeight = parseInt(screen.height);
    if(screenHeight > 900){
        $scope.pageSize = 14;
    }

    var MAINTENANCE_WINDOW_LENGTH = 2 * 60 * 60 * 1000;

    (function filter() {
        if(!addFilter){
            addFilter = {};
        }

        var locationParams = $state.params;
        if(locationParams.type){
            $scope.currentType = locationParams.type;
            addFilter['modelType'] = {
                "label": "modelType",
                "values": [locationParams.type.toUpperCase()]
            }
        }
        if(locationParams.id){
            $scope.currentName = locationParams.id;
            addFilter['modelId'] = {
                "label": "modelId",
                "values": [locationParams.id]
            }
        }
        if(locationParams.modelName){
            $scope.currentName = locationParams.modelName;
            addFilter['modelName'] = {
                "label": "modelName",
                "values": [locationParams.modelName]
            }
        }
        if(locationParams.name){
            $scope.currentName = locationParams.name;
        }
    })();


    $scope.removeFilters = function(){
        $state.go('app.audit',
            {
                type: null,
                id: null,
                name: null,
            }
        );
    };

    $scope.$watch('dateRange.from', function (newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
            setAggConfig();
            $scope.refreshtable = new Date().getTime();
        }
    }, true);
    $scope.$watch('dateRange.to', function (newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
            setAggConfig();
            $scope.refreshtable = new Date().getTime();
        }
    }, true);

    $scope.$watch('data', function(newValue, oldValue) {
        if (newValue && !_.isEqual(newValue, oldValue)) {
            getDataByDates();
        }
    });

    $scope.clearZoom = function() {
        $scope.dateRange.from = null;
        $scope.dateRange.to = null;
        setAggConfig();
        $scope.refreshtable = new Date().getTime();
    };

    function parseConstraintAppid(o){
        return " " + o;
    }
    function parseConstraintBW(o){
        return " " + o + "kbps";
    }

    function parseMaintenanceTimeChange(o) {
        return o? $filter("date")(new Date(o), 'medium') + " - " + $filter("date")(new Date(o + MAINTENANCE_WINDOW_LENGTH), 'medium') : "";
    }

    function parseConstraintTime(o){
        var result = "";
        if(typeof o === "object"){
            for(var innerObject in o){
                switch (innerObject){
                    case "date":
                        result += " Date: " + new Date(o[innerObject]).toDateString();
                        result += ".";
                        break;
                    case "isA":
                        break;
                    case "reoccurring":
                        result += " Reoccurring: " + (o[innerObject]? "Yes" : "No");
                        result += ".";
                        break;
                    case "days":
                        result += " Days:";
                        for(var dayIndex in o[innerObject]){
                            var day = o[innerObject][dayIndex];
                            result += " " + moment().weekday(day-1).format("dddd");
                        }
                        result += ".";
                        break;
                    case "times":
                        result += " Time:";
                        for(var t in o[innerObject]){
                            var time = o[innerObject][t];
                            var fromMoment = moment().hour(Math.floor(time.from / 60)).minute(time.from % 60);
                            var toMoment = moment().hour(Math.floor(time.to / 60)).minute(time.to % 60);

                            result += " " + fromMoment.format("LT") + " to " + toMoment.format("LT");
                        }
                        result += ".";
                        break;
                }
            }
        }
        else {
            if(o === "workingHours"){
                result = "Working Hours.";
            }
        }
        return result;
    }

    function parseObjectToString(o, specialParser){
        var result = "";
        if(typeof o === "object"){
            for(var innerObject in o){
                if(specialParser){
                    result += specialParser(o[innerObject]);
                }
                else {
                    if(typeof o[innerObject] === "object"){
                        result += parseObjectToString(o[innerObject]);

                    }
                    else {
                        result += innerObject + ": " + o[innerObject] + ". ";
                    }
                }
            }
        }
        else {
            if(o === undefined){
                result += EMPTY_STRING;
            }
            else {
                if(specialParser){
                    result += specialParser(o);
                }
                else {
                    result += o;
                }

            }

        }

        return result;
    }

    $scope.showPopUp = function(item){
        $scope.currentChanges = item.change;
        $scope.$root.$emit('$openPopup', 'AuditChangesPopup', 'audit_change_' + item.id, {topMod: 0, leftMod: $('#audit_change_' + item.id).outerWidth()});
    };

    $scope.tableConfig = {
        processData: function(data) {
            for (var i = 0; data[i]; i++) {
                var item = data[i];
                item.creationDate = new Date(item.creationDate);

                if(item.change){
                    var change = JSON.parse(item.change);
                    item.changeNum = 0;
                    item.change = {};
                    angular.forEach(change.fields, function(value, key) {
                        item.changeNum++;
                        item.change[key] = {};
                        item.change[key].name = key;
                        var parser;
                        switch (key){
                            case "Constraint time":
                                parser = parseConstraintTime;
                                break;
                            case "Added Constraint time":
                                parser = parseConstraintTime;
                                break;
                            case "Removed Constraint time":
                                parser = parseConstraintTime;
                                break;
                            case "Constraint limit_bw":
                                parser = parseConstraintBW;
                                item.change[key].name = "Constraint Bandwidth";
                                break;
                            case "Added Constraint limit_bw":
                                parser = parseConstraintBW;
                                item.change[key].name = "Added Constraint Bandwidth";
                                break;
                            case "Removed Constraint limit_bw":
                                parser = parseConstraintBW;
                                item.change[key].name = "Removed Constraint Bandwidth";
                                break;
                            case "Constraint appid":
                                parser = parseConstraintAppid;
                                item.change[key].name = "Constraint Application";
                                break;
                            case "Added Constraint appid":
                                parser = parseConstraintAppid;
                                item.change[key].name = "Added Constraint Application";
                                break;
                            case "Removed Constraint appid":
                                parser = parseConstraintAppid;
                                item.change[key].name = "Removed Constraint Application";
                                break;
                            case "Upgrade Window":
                                parser = parseMaintenanceTimeChange;
                                item.change[key].name = "Upgrade Window";
                                break;
                        }

                        item.change[key].beforeString = parseObjectToString(value.before, parser);
                        item.change[key].afterString = parseObjectToString(value.after, parser);
                        item.change[key].showChange = (item.change[key].beforeString !== EMPTY_STRING || item.change[key].afterString !== EMPTY_STRING);
                        item.change[key].changeType = item.changeType;
                    });
                }
                
                
            }
            return data;
        },
        belongs : function(alert,item){
          return (item.id == alert.auditId);
        },
        showPopUp: function(item){
            $scope.currentChanges = item.change;
            $timeout(function(){
                $scope.$root.$emit('$openPopup', 'AuditChangesPopup', 'audit_change_' + item.id);
            }, 20, false);
        },
        fields : [
            {"label":"Date","path":"creationDate","template":"<span>{{item.creationDate | date:'medium'}}</span>"},
            {"label":"Module","path":"modelModule","template":"<span>{{item.modelModule}}</span>"},
            {"label":"Admin","path":"modifierId","template":"<span>{{item.modifierId}}</span>"},
            {"label":"Action","path":"changeType","template":"<span>{{item.changeType | capitalize}}</span>"},
            {"label":"Object","path":"modelName","template":"<span>{{tableConfig.getModelName(item)}}</span>"},
            {"label":"Details","path":"change","template":"<span ng-if='item.changeNum === 1' ><span ng-repeat='change in item.change' class='auditChange'><span ng-if='change.showChange'> <span class='name'>{{change.name | camelCaseToHuman}} </span><span ng-show='change.name.indexOf(\"Added\") !== 0 && change.name.indexOf(\"Removed\") !== 0 && item.changeType === \"MODIFIED\"'>changed FROM <span class='change-string'>{{change.beforeString}}</span> TO </span><span class='change-string'>{{change.afterString}}</span></span></span></span><span ng-if='item.changeNum > 1' id='audit_change_{{item.id}}' class='action-link' ng-click='tableConfig.showPopUp(item)'>Multiple Fields</a></span>"}
        ],
        type: "ModelChangedAudit",
        rawData: true,
        sortDir: "DESC",
        sortField: "creationDate",
        dateField: "creationDate",
        watchDate: false,
        fixedLayout: true,
        //showLoader: true,
        fromDate: $scope.dateRange.from.getTime(),
        toDate: $scope.dateRange.to.getTime(),
        facets: [ {"id": "modelModule", label: "Module"}, {"id": "modelType", label: "Type"}, {"id": "modifierId", label: "User"}, {"id": "changeType", label: "action"}],
        noSearch: true,
        addFilter: addFilter,
        pageSize: $scope.pageSize,
        afterUpdate: function(){
            setChartMargin();
        },
        getModelName : function(item) {
           var types = {"ACCOUNTMANAGEMENTRULE":"Alert"};
           if(item.modelModule == 'Security' || item.modelModule == 'Healthrule' ){
                 var name = $filter('capitalize')(item.modelType);
                 if(item.modelType == "URLFILTERINGRULE"){
                     name += ("  " + $filter('capitalize')(item.modelName));
                 }
                 name += (" " + item.modelId);
                 return name;
           }
           else {
              var type = types[item.modelType]?types[item.modelType]:$filter('capitalize')(item.modelType);
              return type + " " + $filter('capitalize')(item.modelName);
           }
        },
        openFilters: false
    };


    $scope.$watch('tableConfig.openFilters', function(newValue){
        $timeout(function(){
            setChartMargin();
        }, 1, false);
    });

    var $filtersWrapper, $auditCharDiv, $clearZoom, auditsCharts, ready, readyTimeout;

    angular.element(document).ready(function(){
        ready = true;
        $filtersWrapper = $($element[0]).find('.filters-wrapper');
        $auditCharDiv = $('#auditChartDiv');
        $clearZoom =  $('.audit-buttons');
    });

    function setChartMargin(){
        if(!$filtersWrapper || $filtersWrapper.length == 0) {
            $filtersWrapper = $($element[0]).find('.filters-wrapper');
            return;
        }

        if(!ready){
            readyTimeout = $timeout(function(){
                setChartMargin();
            }, 50);
            return;
        }

        var filtersHeight = $filtersWrapper.outerHeight();
        var auditChartHeight = $auditCharDiv.height();

        $auditCharDiv.css('marginTop', filtersHeight + 50);
        $filtersWrapper.css('marginTop', -(auditChartHeight + filtersHeight + 50));
        $clearZoom.css('marginTop', (auditChartHeight + filtersHeight - 160));

    }

    function setAggConfig(){
        var aggregationConfig = _.clone($scope.aggregationConfig);

        if(aggregationConfig.dataConfig) {
            aggregationConfig.dataConfig.type = "count";
            //aggregationConfig.type = "Events";
            aggregationConfig.dataConfig.fromDate = $scope.dateRange.from.getTime();
            aggregationConfig.dataConfig.toDate = $scope.dateRange.to.getTime();
            aggregationConfig.dataConfig.interval = Math.max(Math.floor((aggregationConfig.dataConfig.toDate - aggregationConfig.dataConfig.fromDate) / 100), 60); // min interval size is 1 min - elastic search data provider expect to get inverval in milliseconds
            aggregationConfig.dataConfig.dateField = "creationDate";
            aggregationConfig.index = 'audit';

            $scope.aggregationConfig = aggregationConfig;

            if ($scope.tableConfig.fromDate !== aggregationConfig.dataConfig.fromDate) {
                $scope.tableConfig.fromDate = aggregationConfig.dataConfig.fromDate;
            }
            if ($scope.tableConfig.toDate !== aggregationConfig.dataConfig.toDate) {
                $scope.tableConfig.toDate = aggregationConfig.dataConfig.toDate;
            }
            DateRangeService.zoomTo(aggregationConfig.dataConfig.fromDate, aggregationConfig.dataConfig.toDate, aggregationConfig.dataConfig.interval);

            return aggregationConfig;
        }
    }

    function getDataByDates() {
        var aggregationConfig = setAggConfig();
        if(aggregationConfig){
            $scope.auData = [];

            store.fetch({
                path: '/facets',
                data: aggregationConfig,
                dataObj: 'json',
                method: 'POST',
                queryParams: {'accountId': $state.params.accountId || ""},
                success: function (data) {
                    if(data && data.facets.length > 0){
                        var itemsData = data.facets[data.facets.length-1].items;
                        itemsData.forEach(function(item){
                            var timeMS = Number(item.label);
                            if (timeMS < aggregationConfig.dataConfig.fromDate){
                                timeMS = aggregationConfig.dataConfig.fromDate
                            }
                            else if (timeMS > aggregationConfig.dataConfig.toDate){
                                timeMS = aggregationConfig.dataConfig.toDate
                            }
                            item.date = new Date(timeMS);
                            $scope.auData.push(item);
                        });
                        drawChart($scope.auData);
                    }
                }
            });
        }
    }

    function drawChart(data) {
        $('#auditChartDiv').css('visibility', 'visible');
        if(auditsCharts){
            auditsCharts.dataProvider = data;
            auditsCharts.validateData();
        }
        else {
            auditsCharts = AmCharts.makeChart("auditChartDiv",
                {
                    "type": "serial",
                    fontFamily: 'Roboto',
                    addClassNames: true,
                    "path": "/public/javascripts/external/amcharts/",
                    theme: "new",
                    "pathToImages": "/public/javascripts/external/amcharts/images/",
                    "categoryField": "date",
                    marginRight: 0,
                    "categoryAxis":{
                        gridAlpha: 0.15,
                        twoLineMode: true,
                        "minPeriod": '600ss',
                        "parseDates": true,
                        dateFormats: [{period:'fff',format:'JJ:NN:SS'},{period:'ss',format:'JJ:NN:SS'},{period:'mm',format:'JJ:NN'},{period:'hh',format:'JJ:NN'},{period:'DD',format:'MMM DD'},{period:'WW',format:'MMM DD'},{period:'MM',format:'MMM'},{period:'YYYY',format:'YYYY'}]

                    },
                    "chartCursor": {
                        cursorPosition: "mouse",
                        selectWithoutZooming: true,
                        "categoryBalloonDateFormat": "JJ:MM, MMM DD, YYYY"
                    },
                    "chartScrollbar": {
                        enabled: false
                    },
                    "trendLines": [],
                    "graphs": [
                        {
                            "fillAlphas": 1,
                            "id": "AmGraph-1",
                            "title": "graph 1",
                            "type": "column",
                            "dateFormat": "JJ, MMM DD, YYYY",
                            "fixedColumnWidth": 10,
                            "valueField": "count",
                            "lineColor":"#42bef7"
                        }
                    ],
                    "valueAxes": [
                        {
                            "id": "ValueAxis-1"
                        }
                    ],
                    "allLabels": [],
                    "balloon": {},
                    "dataProvider": data,
                    listeners: [
                        {
                            event: "init",
                            method: afterInit
                        }]

                });
        }
    }

    function afterInit(chart){
        chart = chart.chart;
        chart.chartCursor.addListener("selected", handleZoom);

        chart.addListener("clickGraphItem", function (event) {
            $scope.dateRange.from = new Date(event.item.category.getTime() - ($scope.aggregationConfig.dataConfig.interval));
            $scope.dateRange.to = new Date(event.item.category.getTime() + ($scope.aggregationConfig.dataConfig.interval));
        });

        chart.chartCursor.addListener("onShowCursor", function (event) {
            event.chart.chartDiv.style.cursor = "zoom-in";
        });
        chart.chartCursor.addListener("onHideCursor", function (event) {
            event.chart.chartDiv.style.cursor = "default";
        });
    }

    function handleZoom(event) {
        var start = Math.min(event.start,event.end);
        var end = Math.max(event.start,event.end);

        $scope.dateRange.from = new Date(start);
        $scope.dateRange.to = new Date(end);
        event.chart.div.style.visibility = 'hidden';
        event.chart.chartCursor.clearSelection();
        return false;
    }

    $scope.$on('$destroy',function() {
        $timeout.cancel(readyTimeout);
    });

}
